import React, { useState } from 'react';

/**
 * Compact column chooser: a small "Columns" button that opens a checkbox panel.
 * Replaces the react-select multi (which rendered every enabled column as a tag
 * and grew to fill half the page). Stays a fixed size regardless of selection.
 *
 * Props:
 *   options:    [{ value, label }]
 *   visibility: { [key]: boolean }
 *   onToggle:   (key) => void
 */
const ColumnsMenu = ({ options = [], visibility = {}, onToggle }) => {
  const [open, setOpen] = useState(false);
  const visibleCount = options.filter((o) => visibility[o.value]).length;

  return (
    <div className="uv-colmenu">
      <button
        type="button"
        className="uv-colmenu__btn"
        data-testid="columns-btn"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span aria-hidden="true">▤</span> Columns
        <span className="uv-colmenu__count">{visibleCount}</span>
        <span aria-hidden="true">▾</span>
      </button>

      {open && (
        <>
          <div className="uv-colmenu__backdrop" onClick={() => setOpen(false)} />
          <div className="uv-colmenu__panel" data-testid="columns-panel" role="menu">
            <div className="uv-colmenu__head">Show columns</div>
            {options.map((o) => (
              <label key={o.value} className="uv-colmenu__row">
                <input type="checkbox" checked={!!visibility[o.value]} onChange={() => onToggle(o.value)} />
                <span>{o.label}</span>
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ColumnsMenu;
